import { render } from "./ItemConfigurationRow.vue?vue&type=template&id=d9b9a16a"
import script from "./ItemConfigurationRow.vue?vue&type=script&lang=js"
export * from "./ItemConfigurationRow.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bertog/Code/aitmes/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__